/**
 * The strip's legend (20/10/2026): only the states the day on screen has,
 * each with its colour and words, so the strip reads without a guess.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { cn } from '@/lib/utils';

import type { DayPlanContainerRow } from '../../../drop-generator.types';
import { dropState, type DropState, STATE_WORDS } from './drop-state';
import { STATE_CLASS } from './DropStrip';

const ORDER: DropState[] = ['sent', 'sending', 'scheduled', 'staged', 'held', 'left', 'shadow', 'overdue', 'waiting', 'planned', 'stopped', 'skipped'];

export const StripLegend: FC<{ containers: DayPlanContainerRow[]; now: Date }> = ({ containers, now }) => {
  const present = new Set(containers.flatMap((c) => c.drops.map((d) => dropState(d, now))));
  const shown = ORDER.filter((s) => present.has(s));
  if (shown.length === 0) return null;
  return (
    <ul className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground" aria-label="What the colours mean" data-testid="strip-legend">
      {shown.map((state) => (
        <li key={state} className="flex items-center gap-1.5">
          <span className={cn('h-2 w-3 rounded-[1px]', STATE_CLASS[state])} aria-hidden />
          {STATE_WORDS[state]}
        </li>
      ))}
    </ul>
  );
};
